import { io, Socket } from "socket.io-client";
import { tokenStorage } from "./services/authService";
import { EventEmitter } from "events";

const token = tokenStorage.getAccessToken();
const emitter = new EventEmitter();

export const socket_client: Socket = io(
  process.env.REACT_APP_YARN_FOCUS_API_URL?.split("/api/v1")[0],
  {
    autoConnect: false,
    auth: {
      token: token,
    },
  }
);

let isConnected = navigator.onLine && socket_client.connected;

const emitStatus = (status: boolean) => {
  isConnected = status;
  emitter.emit("statusChange", status);
};

window.addEventListener("online", () => {
  if (socket_client.connected) emitStatus(true);
});

window.addEventListener("offline", () => {
  emitStatus(false);
});

socket_client.on("connect", () => {
  if (navigator.onLine) emitStatus(true);
});

socket_client.on("disconnect", () => {
  emitStatus(false);
});

socket_client.on("reconnect_error", (error) => {
  emitStatus(false);
});

export const checkConnectionStatus = () => isConnected;
